interface InputState {
  value: string;
  selection: { start: number; end: number } | null;
}

interface BeforeMaskedStateChangeStates {
  previousState?: InputState;
  currentState?: InputState;
  nextState: InputState;
}

export const beforeDateMaskedStateChange = ({
  nextState
}: BeforeMaskedStateChangeStates): InputState => {
  const { value } = nextState;
  let newValue = value;

  // Разбиваем на компоненты
  const parts = value.split('.');

  if (parts[0]) {
    // День: ограничиваем 01-31
    const day = parseInt(parts[0], 10);
    if (day > 31) {
      parts[0] = '31';
    } else if (parts[0].length === 2 && day === 0) {
      parts[0] = '01';
    }
  }

  if (parts[1]) {
    // Месяц: ограничиваем 01-12
    const month = parseInt(parts[1], 10);
    if (month > 12) {
      parts[1] = '12';
    } else if (parts[1].length === 2 && month === 0) {
      parts[1] = '01';
    }
  }

  if (parts[2]) {
    // Год: ограничиваем минимум 2000
    const year = parseInt(parts[2], 10);
    if (parts[2].length === 4 && year < 2000) {
      parts[2] = '2000';
    }
  }

  newValue = parts.join('.');

  return {
    ...nextState,
    value: newValue
  };
};
